import { Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import { ClipboardService } from 'ngx-clipboard';
import {EventService} from "../../core/services/event.service";
import {Angulartics2} from "angulartics2";
import { HybridToolsService } from '../../core/services/hybrid-tools.service';

declare var $: any;
declare var jQuery: any;

@Component({
    selector: 'app-templates',
    templateUrl: './template.component.html',
    styleUrls: ['./email-templates.component.scss']
})
export class TemplateComponent implements OnInit {
    messageAlertVisible: boolean;
    subjectAlertVisible: boolean;
    user: any = {};
    @Input() template: any;
    @Input() templateOpen: boolean;
    @Output() templateOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    constructor(private clipboard: ClipboardService,
                private modalService: NgbModal,
                public eventService: EventService,
                private angulartics2: Angulartics2,
                private renderer: Renderer2,
                private hybridToolsService: HybridToolsService
                ) {}

    copyMessageToClipboard = () => {
        if (this.messageAlertVisible) {
            this.messageAlertVisible = false;
        } else {
            this.clipboard.copyFromContent($('<div>').html(this.template.content).text()); //FIXME: migration, this.renderer);
            this.messageAlertVisible = true;
            this.subjectAlertVisible = false;
        }
        this.angulartics2.eventTrack.next({
            action: 'Copy Message',
            properties: {category: 'Email Center'}
        });
    }

    copySubjectToClipboard = () => {
        if (this.subjectAlertVisible) {
            this.subjectAlertVisible = false;
        } else {
            if (this.hybridToolsService.isMobileApp()) {
                var $temp = $("<input>");
                $("body").append($temp);
                $temp.val($('<div>').html(this.template.content).text()).select();
                document.execCommand("copy");
                $temp.remove();
            } else {
                this.clipboard.copyFromContent(this.template.subject); //FIXME: migration, this.renderer);
            }
            this.subjectAlertVisible = true;
            this.messageAlertVisible = false;
        }
        this.angulartics2.eventTrack.next({
            action: 'Copy Subject',
            properties: {category: 'Email Center'}
        });
    }

    openMessage(content) {
        this.modalService.open(content);
        this.angulartics2.eventTrack.next({
            action: 'Help',
            properties: {category: 'Email Center'}
        });
    }

    openSubject(subject) {
        this.modalService.open(subject);
    }

    ngOnInit() {
    }

}
